import { render, staticRenderFns } from "./lkuSalesadvcategory.vue?vue&type=template&id=6f1d63ac"
import script from "./lkuSalesadvcategory.vue?vue&type=script&lang=js"
export * from "./lkuSalesadvcategory.vue?vue&type=script&lang=js"
import style0 from "./lkuSalesadvcategory.vue?vue&type=style&index=0&id=6f1d63ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports